import { DeleteOutlined, EditOutlined, EyeOutlined, MoreOutlined, RollbackOutlined } from "@ant-design/icons";
import { Dropdown, Space } from "antd";
import TableAntd from "components/elements/Table/Table";
import StatusTag from "components/elements/TagCustom/StatusTag";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { formatDateTime } from "utils/formatter";

const OffsiteWorkTable = ({
  isLoading = false,
  pagination = {},
  dataSource = [],
  modalType = "view",
  onEdit = () => { },
  onView = () => { },
  onDelete = () => { },
  onStatus = () => { },
  onChange = () => { },
  isEmployee = false,
  isHistory = false
}) => {

  function formatDate(dateString) {
    if (!dateString) return;
    const date = dayjs(dateString);
    return date.format(i18n.language === "en" ? "DD/MM/YYYY" : `DD/MM/${date.year() + 543}`);
  }

  function readMode(status, record) {
    let items = []
    if (String(status)?.toLowerCase?.() == 'Draft'?.toLowerCase?.()) {
      if (roles.includes("UPDATE_MY_DOCUMENT|MY_REQUEST|OFFSITE_WORK") && !isEmployee) {
        items.push({
          key: "1",
          onClick: () => onEdit(record),
          label: `${t("action.edit")}`,
          icon: (
            <EditOutlined style={{ fontSize: "18px", color: "gray" }} />
          ),
        })
      }
      if (roles.includes("DELETE_MY_DOCUMENT|MY_REQUEST|OFFSITE_WORK") && !isEmployee) {
        items.push({
          key: "2",
          onClick: () => onDelete(record),
          label: `${t("action.delete")}`,
          icon: (
            <DeleteOutlined style={{ fontSize: "18px", color: "gray" }} />
          ),
        })
      }
    }
    if ((roles.includes("ACCESS_MY_DOCUMENT|MY_REQUEST") && !isEmployee) || (isEmployee && roles.includes("ACCESS_EMPLOYEE|DOCUMENT|OFFSITE_WORK"))) {
      items.push({
        key: "3",
        onClick: () => onView(record),
        label: `${t("action.view")}`,
        icon: (
          <EyeOutlined style={{ fontSize: "18px", color: "gray" }} />
        ),
      },)
    }
    if ((roles.includes("ACCESS_MY_DOCUMENT|MY_REQUEST") || (isEmployee && roles.includes("ACCESS_EMPLOYEE|DOCUMENT|OFFSITE_WORK"))) && record?.["approveStatusEn"] == 'Approved' && record?.rejectFlow == null) {
      items.push({
        key: "4",
        onClick: () => onView(record, "reject"),
        label: `${t("common.reject")}`,
        icon: (
          <RollbackOutlined style={{ fontSize: "18px", color: "gray" }} />
        ),
      },)
    }
    return items || []
  }
  const i = 0;
  const { t, i18n } = useTranslation();
  const { roles } = useSelector((state) => state.company);

  const processedDataSource = dataSource.map(item => {
    if (Array.isArray(item.children) && item.children.length === 0) {
      return { ...item, children: null };
    }
    return item;
  });

  const showActionBar = isEmployee
    ? roles.includes("ACCESS_EMPLOYEE|DOCUMENT|OFFSITE_WORK")
    : (!isHistory &&
      (roles.includes("UPDATE_MY_DOCUMENT|MY_REQUEST|OFFSITE_WORK") ||
        roles.includes("DELETE_MY_DOCUMENT|MY_REQUEST|OFFSITE_WORK")));

  const columns = [
    {
      title: <div className="text-table">{t("workin_location.label.reqid")}</div>,
      dataIndex: "sequence",
      key: "sequence",
      align: "center"
    },
    isHistory && {
      title: <div className="text-table">{t("workin_location.label.approvalSequence")}</div>,
      dataIndex: "sequenceNumber",
      key: "sequenceNumber",
      render: (_, record, index) => {
        const getApprovalOrder = () => {
          let order = 1;
          if (record.children === null) {
            order = 1;
          } else if (record.children === undefined) {
            order = index + 2;
          } else {
            order = 1;
          }
          return `${t("workin_location.label.approvalNumber")} ${order}`;
        };

        return getApprovalOrder();
      },
    },
    {
      title: <div className="text-table">{t('workin_location.label.worktype')}</div>,
      dataIndex: "workType",
      key: "workType",
      visible: true,
      align: "center",
      render: (text, record) => {
        return i18n.language === 'en' ? <span>{record?.workTypeNameEn}</span> : <span>{record?.workTypeName}</span>
      }
    },
    {
      title: <div className="text-table">{t('employee.label.create-date')}</div>,
      dataIndex: "createDate",
      key: "createDate",
      visible: true,
      align: "center",
      render: (_, record) => {
        return record?.createDate ? formatDate(record?.createDate) : "-"
      }
    },
    {
      title: <div className="text-table">{t('start-date')}</div>,
      dataIndex: "offsiteWorkDate",
      key: "offsiteWorkDate",
      visible: true,
      align: "center",
      render: (_, record) => {
        return record?.offsiteWorkDate ? formatDate(record?.offsiteWorkDate) : "-"
      },
    },
    {
      title: <div className="text-table">{t('end-date')}</div>,
      dataIndex: "endDate",
      key: "endDate",
      visible: true,
      align: "center",
      render: (_, record) => {
        return record?.endDate ? formatDate(record?.endDate) : "-"
      },
    },
    {
      title: <div className="text-table" >{t("leave_type.label.start-time")}</div>,
      dataIndex: "offsiteWorkDateTimeString",
      key: "offsiteWorkDateTimeString",
      align: "center"
    },
    {
      title: <div className="text-table">{t("leave_type.label.end-time")}</div>,
      dataIndex: "endDateTimeString",
      key: "endDateTimeString",
      align: "center"
    },
    {
      title: <div className="text-table">{t("workin_location.label.duration")}</div>,
      dataIndex: "duration",
      align: "center",
      key: "duration",
      render: (_, record) => {
        if (record?.durationType === "ALLDAY") {
          return record?.totalDuration + " " + t("unit.days");
        }
        else if (record?.durationType === "HOUR") {
          return (record?.totalDurationHour + " " + t("unit.hours"))
            + " " + (record?.totalDurationMinute + " " + t("unit.minutes"))
        } else return ""
      }
    },
    {
      title: <div className="text-table">{t("levave_type_action")}</div>,
      dataIndex: "description",
      key: "description",
      align: "center",
    },
    isHistory && {
      title: <div className="text-table">{t('leave_type.label.approvalDate')}</div>,
      dataIndex: "approverDate",
      key: "approverDate",
      align: "center",
      render: (_, record) => {
        return record?.approverDate ? formatDateTime(record?.approverDate) : "-"
      }
    },
    isHistory && {
      title: <div className="text-table">{t('request_all.approver')}</div>,
      dataIndex: "approverBy",
      key: "approverBy",
      align: "center",
      render: (_, record) => {
        if (record?.approverBy?.nameAndSurname !== null && record?.approverBy?.nameAndSurnameEn !== null) {
          return i18n.language === 'en' ? record?.approverBy?.nameAndSurnameEn : record?.approverBy?.nameAndSurname
        } else if (record?.approverBy?.name !== null && record?.approverBy?.nameEn) {
          return i18n.language === 'en' ? record?.approverBy?.nameEn : record?.approverBy?.name
        }
        return "-"
      }
    },
    {
      title: <div className="text-table">{t("workin_location.label.status")}</div>,
      dataIndex: "status",
      key: "status",
      align: "center",
      render: (text, record) => {
        let language = i18n.language == 'en' ? "En" : ""
        return <StatusTag value={(record?.["approveStatus" + language])} />
      }
    },
    // !isHistory && (roles.includes("UPDATE_MY_DOCUMENT|MY_REQUEST|OFFSITE_WORK") || roles.includes("DELETE_MY_DOCUMENT|MY_REQUEST|OFFSITE_WORK") ? actionBar() : {})
    showActionBar ? actionBar() : {}
  ].filter(Boolean);

  function actionBar() {
    if (!isEmployee || roles.includes("ACCESS_EMPLOYEE|DOCUMENT|OFFSITE_WORK")) {
      return {
        title: <div className="text-table">{ }</div>,
        key: "action",
        align: "center",
        render: (_, record) => (
          <Space size="middle">
            <Dropdown
              menu={{
                items: readMode(_.approveStatusEn, record)
              }}
            >
              <MoreOutlined style={{ fontSize: "25px", color: "gray" }} />
            </Dropdown>
          </Space>
        ),
      }
    } else {
      return {}
    }
  }

  return (
    <TableAntd
      loading={isLoading}
      pagination={{
        ...pagination,
        showTotal: (total, range) =>
          t("paginate.description")
            .replace("{min}", range[0])
            .replace("{max}", range[1])
            .replace("{total}", total),
      }}
      dataSource={processedDataSource}
      rowKey={(record) => record.id}
      columns={columns}
      onChange={onChange}
    />
  );
};

export default OffsiteWorkTable;
